module.exports = __webpack_public_path__ + "img/img_03.4f077fdf.jpg";